import { Provider } from 'mobx-react';
import * as React from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import { modalStore } from 'ws-react-modal-dialog';
import { DynamicImport, NotFound } from 'ws-voice-infinity-global-module/lib/components';
import { authStore, eventStore, globalStore, mainPageStore, notificationStore, subscriptionStore } from 'ws-voice-infinity-global-module/lib/store';
import MainWrap from '../modules/Wrappers/mainWrap/mainWrapComponent';

const stores = { authStore, eventStore, globalStore, mainPageStore, modalStore, notificationStore, subscriptionStore };

export default class MainRouter extends React.Component<{
    history?: any;
    location?: any;
}> {
    render() {
        return (
            <Provider
                {...stores}
            >
                <HashRouter>
                    <Switch>
                        <MainWrap
                            location={this.props.location}
                        >
                            <Switch>
                                <Route
                                    exact
                                    path="/"
                                    component={(props: any) => <DynamicImport
                                        load={() => import('../modules/Global/components/main/mainComponent')}
                                        propsParent={props}
                                    />}
                                />
                                <Route
                                    exact
                                    path="/favorite/cameras"
                                    component={(props: any) => <DynamicImport
                                        load={() => import('../modules/Cameras/pages/favoriteCamerasList/favoriteCamerasListContainer')}
                                        propsParent={props}
                                    />}
                                />
                                <Route
                                    component={NotFound}
                                />
                            </Switch>
                        </MainWrap>
                        <Route
                            component={NotFound}
                        />
                    </Switch>
                </HashRouter>
            </Provider>
        );
    }
}
